
<template>
	<article class="form-section-print-view">
		<div class="letterhead d-flex flex-row justify-content-between align-items-center">
			<img v-if="companyLogoSrc" :src="companyLogoSrc" class="logo mr-3">
			<div>
				<h3>
					Equipment Maintenance Log
					<div><small class="text-muted">Equipment Maintenance Log</small></div>
				</h3>

				<button class="btn btn-light print-button" v-on:click="printPage">
					<i class="fa fa-print"></i>
					Print
				</button>
			</div>
		</div>

		<div class="form-details" v-if="logFetched">

			<table>

				<h4 class="title">Equipment Details</h4>

				<tr>
					<th>Type: </th>
					<td>{{ maintenanceLog.Equipment.EquipmentType.name }}</td>
				</tr>
				<tr>
					<th>Description: </th>
					<td>{{ maintenanceLog.Equipment.description }}</td>
				</tr>
				<tr>
					<th>Serial #: </th>
					<td>{{ maintenanceLog.Equipment.serial_num }}</td>
				</tr>
				<tr>
					<th>Date Acquired: </th>
					<td>{{ maintenanceLog.Equipment.date_acquired }}</td>
				</tr>

			</table>

		</div>


		<section class="form-section-print-view">
			<h4>Participants</h4>

			<table-list
				record-name="Work Holder"
				:fields="participantFields"
				:records="mutatedParticipants"
				:hide-record-count="true"
				:has-edit="false"
				:loading="!logFetched">
			</table-list>
		</section>


		<section v-if="logFetched" class="form-section form-section-print-view">

			<h4>Maintenance Details</h4>

			<div class="field-container">
				<div class="field field-type-text">
					<h5>Maintenance Type</h5>
					<div class="pre-field">{{ maintenanceLog.type }}</div>
				</div>
			</div>

			<div class="field-container">
				<div class="field field-type-text">
					<h5>Date Done</h5>
					<div class="pre-field">{{ maintenanceLog.date_done }}</div>
				</div>
			</div>

			<div class="field-container">
				<div class="field field-type-text">
					<h5>Odometer/Hrs</h5>
					<div class="pre-field">{{ maintenanceLog.mileage_or_time }}</div>
				</div>
			</div>

			<div class="field-container">
				<div class="field field-type-boolean">
					<h5>Done in-house?</h5>
					<div class="pre-field">
						<i class="fa" :class="{'fa-times' : maintenanceLog.in_house == 0, 'fa-check': maintenanceLog.in_house == 1}"></i>
					</div>
				</div>
			</div>

			<div class="field-container">
				<div class="field field-type-static-paragraph">
					<h5>Work Done</h5>
					<div class="pre-field">{{ maintenanceLog.work_done }}</div>
				</div>
			</div>

			<div v-if="logFiles && logFiles.length > 0">
				<div class="field field-type-attachments">

					<h5>Image Attachments</h5>

					<div class="row">

						<image-panel v-for="image in mutatedFiles.filter(file => file.type == 'Image')"
							class="col float-left"
							:key="'panel_' + image.src"
							:readonly="true"
							:expand-on-click="true"
							:image-url="image.thumbSrc ? image.thumbSrc : false"
							:expand-url="image.src ? image.src : false"
							style="max-width: 250px; max-height: 200px">
						</image-panel>

					</div>

					<h5 class="mt-4">File Attachments</h5>

					<div>
						<file-list-item v-for="file in mutatedFiles.filter(file => file.type != 'Image')"
							:key="'list_item_' + file.src"
							:filename="file.original_filename"
							:size-kb="file.file_size_kb"
							:src="file.src"
							:non-editable="true">
						</file-list-item>
					</div>

				</div>
			</div>

		</section>

	</article>

</template>


<script type="text/javascript">

import SignatureField from "@/components/SignatureField"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import ImagePanel from "@/components/ImagePanel"
import FileListItem from "@/components/FileListItem"

export default {
	name: "MaintenanceLogPrint",
	components: {
		SignatureField,
		TableList,
		Field,
		ImagePanel,
		FileListItem
	},
	mixins: [],
	data() {
		return {
			maintenanceLog: {},
			logFetched: false,
			participantFields: [
				{label: "Role",key:'role'},
				{label: "Name",key:'name'},
				{label: "Company Name",key:'company_name'},
				{label: "Email",key:'email'},
				{label: "Phone",key:'phone'},
			],
			logParams: {
				include: [
					{
						model: "User",
						fields: ["id", "slug", "first_name", "last_name", "email", "phone", "phone_mobile"]
					},
					{
						model: "Equipment",
						fields: ["type_id", "description", "serial_num", "date_acquired"],
						include: [
							{
								model: "EquipmentType",
								fields: ["name"]
							}
						]
					}
				]
			},
			updatedByParams: {
				fields: ["id", "slug", "first_name", "last_name", "email", "phone", "phone_mobile"]
			},
			updatedBy: {},
			logFiles: []
		}
	},
	computed: {
		companyLogoSrc() {
			let fileImage = this.$store.company.ProfileImage
			if (fileImage)
				return window.apiRoot+"resources/profile-images/"+fileImage.slug+"/"+fileImage.filename
			else
				return false
		},
		mutatedParticipants() {

			if (!('DoneBy' in this.maintenanceLog) || !this.maintenanceLog.DoneBy)
				return []

			this.maintenanceLog.date_done = this.formatDateTimeToLocal(this.maintenanceLog.date_done, "full-date")
			this.maintenanceLog.Equipment.date_acquired = this.formatDateTimeToLocal(this.maintenanceLog.Equipment.date_acquired, "full-date")

			let participants = [this.maintenanceLog.DoneBy]

			if (participants[0])
				participants[0].role = "Serviced By"

			participants = participants.map(participant => {
				participant.name = participant.first_name + " " + participant.last_name
				participant.company_name = this.$store.company.company_name
				return participant
			})
			return participants
		},
		mutatedFiles() {
			return this.logFiles.map(file => {

				// User is verified
				if (file.thumb_filename)
					file.thumbSrc = this.$store.apiRoot + 'resources/images/' + this.$store.sessionToken + '/' + file.thumb_filename
				else
					file.thumbSrc = false

				if (file.filename)
					file.src = this.$store.apiRoot + 'resources/images/' + this.$store.sessionToken + '/' + file.filename
				else
					file.src = false

				console.log(file)

				return file
			})
		},
	},
	methods: {
		printPage() {
			window.print()
		},
		fetchMaintenanceLogFiles(logID) {
			let vm = this

			let params = {
				fields: ["LibraryUpload"],
				include: [
					{
						// Attached files
						model: "LibraryUpload",
						fields: ["filename", "thumb_filename","type","original_filename","file_size_kb"]
					}
				]
			}

			this.spinner(true)

			this.getJSON("EquipmentMaintenanceLog/find/"+logID,params,true).then(response => {
				vm.spinner(false)
				if (response.success) {
					vm.logFiles = response.data.LibraryUpload
				}
			})
		},
		fetchMaintenanceLog() {
			let vm = this

			vm.spinner(true)

			this.getJSON("EquipmentMaintenanceLog/find/"+vm.$route.params.slug, vm.logParams).then(response => {
				vm.spinner(false)
				if (response.success) {
					vm.maintenanceLog = response.data
					vm.fetchMaintenanceLogFiles(response.data.id)
					vm.logFetched = true
				}
			})
		}
	},
	created() {
		this.fetchMaintenanceLog()
		this.$store.printMode = true
	}
}
</script>



<style type="text/css" scoped>
article {
	max-width: 1000px;
	margin: auto;
}

.form-details {
	margin-top: 30px;
	padding: 15px;
	background-color: #6c757d;
	color: white;
}

@media print {
	.print-button {
		display: none;
	}
}

.title {
	margin: 0px;
	padding: 0px;
}


.form-section pre {
 margin-bottom: 0;
}

.form-section-print-view {
	border: 1px solid #e0e0e0;
	padding: 15px;
	padding-top: 0;
	background-color: white;
}

.form-section-print-view h4 {
	padding: 15px;
	background: #6c757d;
	color: white;
	margin-left: -15px;
	margin-right: -15px;
	text-decoration: none;
}

.form-section-print-view.highlighted-section h4 {
	background: #b1690c;
}

.form-section-print-view .field-container {
	border-bottom: 1px solid #e0e0e07a;
}

.form-section-print-view .field {
	padding-top: 10px;
	padding-bottom: 10px;
}

.form-section-print-view .field:last-child {
	border-bottom: none;
}

.form-section-print-view .field h5 {
	margin-bottom: 0;
}

.form-section-print-view .field.field-type-boolean,
.form-section-print-view .field.field-type-text {
	display: flex;
}

.form-section-print-view .field.field-type-boolean h5,
.form-section-print-view .field.field-type-text h5 {
	width: 80%;
}

.form-section-print-view .field.field-type-boolean > div,
.form-section-print-view .field.field-type-text > div {
	width: 40%;
}

.field.field-type-static-paragraph > div {
	width: 100%;
	margin-top: 5px;
	font-size: 100%;
}

.form-section-print-view .field-type-list,
.form-section-print-view .field-type-weather,
.form-section-print-view .field-type-table {
	display: block;
}

.field.field-type-attachments > div {
	width: 100%;
	margin-top: 14px;
	padding: 0 6px;
	font-size: 100%;
}

.form-section-print-view .pre-field {
	font-size: 110%;
	font-family: inherit;
}

.form-section-print-view .conditional-remarks {
	margin-bottom: 10px;
}

.form-section-print-view .conditional-remarks label {
	font-weight: bold;
}

@media print {
	pre {
		border: none!important;
	}

	article {
		background-color: white!important;
	}
}
</style>
